<template>
  <div style="width: 100%;position: relative;">
    <div class="detail-menu flex-rs">
      <div :class="['detail-menu-single font-size14 flex-cm',item.isactive ? 'green-font green-border' : 'gray-font gray-border']" v-for="(item,index) in tablist" @click="selecttab(index)">{{item.name}}{{item.submissionCount>-1?'('+item.submissionCount+')':''}}</div>
    </div>
    <slot></slot>
  </div>

</template>

<script>
  import App from '../util/comfun'
  export default{
      name:'tab',
      props:{
        auto:{
          type:Boolean,
          value:true
        },
        id:String,
        selectedIndex:{
          type:Number,
          value:1,
        }
      },
      data(){
        return {
          tablist:[
            {
              name:'全部投稿',
              isactive:true,
              type:'new'
            },
            {
              name:'热门',
              isactive:false,
              type:'hot'
            },
          ],
        }
      },
      watch:{
        id(){
          if(this.auto==false){
            this.tablist=[];
          }else{
            this.tablist=[
              {
                name:'全部投稿',
                isactive:true,
                type:'new'
              },
              {
                name:'热门',
                isactive:false,
                type:'hot'
              },
            ]
            this.$emit('tellgroup',{groupid:0,type:'new'})
          }
          this.getgroup();
        },
        selectedIndex(val){
          console.log(val)
          this.selecttab(val);
        }
      },
      methods:{
        getgroup(){
          App.Contribution.GetGroupByContribution({
            cid:this.id,
          }).then(json=>{
            if(json.code==200){
              json.data.forEach((v,i)=>{
                v.type='group_'+v.id;
                v.isactive=false;
                v.total=Number(v.submissionCount);
                if(this.auto==false){
                  if(i==0){
                    v.isactive=true;
                    this.$emit('tellgroup',{groupid:v.id,type:v.type,total:v.submissionCount})
                  }
                }
              })
              this.tablist=this.tablist.concat(json.data)
            }
          })
          return
          this.$http({
            url:'https://pfotoo.com?s=App.Contribution.GetGroupByContribution'+this.$getsign(),
            params:{
              cid:this.id,
            },
            method:'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res)=>{
            console.log(res.body)
            let json=res.body;
            if(res.body.ret==200){
               json.data.forEach((v,i)=>{
                 v.type='group_'+v.id;
                 v.isactive=false;
                 v.total=Number(v.total);
                 if(this.auto==false){
                  if(i==0){
                    v.isactive=true;
                    this.$emit('tellgroup',{groupid:v.id,type:v.type,total:v.total})
                  }
                 }
               })
               this.tablist=this.tablist.concat(json.data)
            }
          })
        },
        selecttab(index){
          console.log(index)
          let tablist=this.tablist,prev=0;
          tablist.forEach((v,i)=>{
            if(v.isactive==true){
              prev=i;
            }
            if(i==index){
              if(v.type!='new' && v.type!='hot'){
                console.log(v)
                this.$emit('tellgroup',{groupid:v.id,type:v.type,total:v.total})
              }else{
                this.$emit('tellgroup',{groupid:0,type:v.type})
              }
            }
          })
         this.tablist[prev].isactive=false;
         if(index!=-1){
           this.tablist[index].isactive=true;
         }
        },
      },
      mounted(){
        if(this.auto==false){
          this.tablist=[];
        }else{
          this.$emit('tellgroup',{groupid:0,type:'new'})
        }
        this.getgroup();
      }
  }
</script>

<style>
  .detail-menu-single {
      width: 90px;
      height: 26px;
      border-radius: 16px;
      margin-right: 30px;
      margin-bottom: 15px;
      cursor: pointer;
      font-weight: 500;
  }
  .gray-border {
      border: 1px solid #bfc3c2;
  }
  .green-border {
      border: 1px solid #3dc4a7;
  }
</style>



// WEBPACK FOOTER //
// src/components/tab.vue